export default __webpack_public_path__ + "static/media/logo.09529f1b.svg";